import { Form as FormikForm } from "formik"

import {
    Avatar,
    Button as UiButton,
    FormikAutoCompleteWithChips,
    FormikTextField,
    ListItemIcon as L2RListItemIcon,
    Skeleton as UiSkeleton,
    Typography as UiTypography,
    styled,
    styledForMobile,
    Typography,
} from "@l2r-front/l2r-ui"

export const Button = styledForMobile(UiButton)(({ isMobile }) => ({
    flex: isMobile && "1 1 auto",
    textTransform: "none",
}))

export const SubmitButton = styledForMobile(UiButton)(({ isMobile, theme }) => ({
    flex: isMobile && "1 1 auto",
    marginLeft: theme.spacing(2),
    textTransform: "capitalize",
}))

export const ButtonsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    padding: theme.spacing(4, 0, 0, 0),
}))

export const Wrapper = styledForMobile("div")(({ isMobile }) => ({
    display: "flex",
    marginLeft: "auto",
    justifyContent: isMobile && "space-between",
}))

export const InputsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: theme.spacing(4),
}))

export const AutoCompleteFilter = styled(FormikAutoCompleteWithChips)(() => ({
    width: "100%",

    "& .MuiAutocomplete-popupIndicator": {
        transform: "none",
    },
}))

export const FormWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(8, 4),
}))

export const Skeleton = styled(UiSkeleton)(({ theme }) => ({
    height: "468.5px",
    margin: theme.spacing(8, 4),
    transform: "scale(1)",
    width: "auto",
}))

export const Error = styled(UiTypography)(({ theme }) => ({
    color: theme.palette["texts/text-error"].main,
    margin: theme.spacing(8, 4),
    textAlign: "center",
    width: "auto",
}))

export const Form = styled(FormikForm)(() => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
}))

export const DatesContainer = styled("div")(() => ({
    alignItems: "center",
    display: "flex",
    width: "100%",
}))

export const DateSeparator = styled(Typography)(({ theme }) => ({
    margin: theme.spacing(0, 4),
}))

export const TextField = styled(FormikTextField)(() => ({
    ".MuiOutlinedInput-notchedOutline": {
        borderRadius: 9999,
    },
}))

export const ChipAvatar = styled(Avatar)(({ theme }) => ({
    border: `1px solid ${theme.palette.primary.main} !important`,
    backgroundColor: "white",
    color: `${theme.palette.primary.main} !important`,
}))

export const Image = styled("img")({
    height: "24px",
    width: "24px",
    padding: 0,
    margin: 0,
})

export const ListItemIcon = styled(L2RListItemIcon)(({ theme }) => ({
    paddingRight: theme.spacing(2),
    minWidth: "auto",
}))